// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ============================================================
   HomeAiReplace — "Courses we offer" with parallax background
   Prefix: home_course_ho_pg_ · no :root variables · no green
   --p (set by JS on the section) = scroll progress from -1 to 1
   ============================================================ */

.home_course_ho_pg_section {
  --p: 0;
  position: relative;
  width: 100%;
  padding: 80px 0 96px;
  background: linear-gradient(180deg, #f3ecff 0%, #f8f4ff 55%, #fbf8ff 100%);
  font-family: "Manrope", "Roboto", sans-serif;
  color: #0f0a2a;
  overflow: hidden;
  isolation: isolate;
}

.home_course_ho_pg_container {
  position: relative;
  z-index: 2;
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 24px;
}

/* ============================================================
   Parallax background — each layer moves at its own speed
   ============================================================ */

.home_course_ho_pg_bg {
  position: absolute;
  inset: 0;
  z-index: 0;
  pointer-events: none;
  overflow: hidden;
}

.home_course_ho_pg_blob {
  position: absolute;
  border-radius: 50%;
  filter: blur(10px);
  will-change: transform;
}

/* far layer: slow, big soft glows */
.home_course_ho_pg_blob_one {
  top: -160px;
  left: -180px;
  width: 560px;
  height: 560px;
  background: radial-gradient(circle, rgba(106, 31, 194, 0.26) 0%, rgba(106, 31, 194, 0) 68%);
  transform: translate3d(0, calc(var(--p) * 150px), 0);
}

.home_course_ho_pg_blob_two {
  top: 30%;
  right: -200px;
  width: 620px;
  height: 620px;
  background: radial-gradient(circle, rgba(224, 168, 61, 0.26) 0%, rgba(224, 168, 61, 0) 68%);
  transform: translate3d(calc(var(--p) * -60px), calc(var(--p) * 90px), 0);
}

.home_course_ho_pg_blob_three {
  bottom: -220px;
  left: 20%;
  width: 640px;
  height: 640px;
  background: radial-gradient(circle, rgba(74, 26, 158, 0.2) 0%, rgba(74, 26, 158, 0) 68%);
  transform: translate3d(calc(var(--p) * 80px), calc(var(--p) * 130px), 0);
}

/* mid layer: dot grid drifting slowly */
.home_course_ho_pg_dots {
  position: absolute;
  inset: -120px 0;
  background-image: radial-gradient(circle, rgba(74, 26, 158, 0.18) 1.4px, transparent 1.6px);
  background-size: 34px 34px;
  mask-image: linear-gradient(180deg, transparent 0%, #000 25%, #000 75%, transparent 100%);
  opacity: 0.55;
  transform: translate3d(0, calc(var(--p) * 60px), 0);
  will-change: transform;
}

/* faint diagonal lines moving the other way */
.home_course_ho_pg_lines {
  position: absolute;
  inset: -160px 0;
  background-image: repeating-linear-gradient(
    115deg,
    rgba(224, 168, 61, 0.1) 0,
    rgba(224, 168, 61, 0.1) 1px,
    transparent 1px,
    transparent 84px
  );
  mask-image: linear-gradient(90deg, transparent 0%, #000 35%, transparent 100%);
  transform: translate3d(0, calc(var(--p) * -90px), 0);
  will-change: transform;
}

/* near layer: floating shapes, each with its own speed (--k) */
.home_course_ho_pg_shape {
  position: absolute;
  display: block;
  color: rgba(106, 31, 194, 0.5);
  transform: translate3d(0, calc(var(--p) * var(--k) * 1px), 0) rotate(calc(var(--p) * 40deg));
  will-change: transform;
}

.home_course_ho_pg_shape_ring {
  border: 2px solid rgba(106, 31, 194, 0.28);
  border-radius: 50%;
}

.home_course_ho_pg_shape_ring_gold {
  border: 2px solid rgba(224, 168, 61, 0.7);
  border-radius: 50%;
}

.home_course_ho_pg_shape_dot {
  border-radius: 50%;
  background: rgba(106, 31, 194, 0.35);
}

.home_course_ho_pg_shape_dot_gold {
  border-radius: 50%;
  background: #e0a83d;
  opacity: 0.8;
}

.home_course_ho_pg_shape_diamond {
  border: 2px solid rgba(224, 168, 61, 0.75);
  border-radius: 4px;
  transform: translate3d(0, calc(var(--p) * var(--k) * 1px), 0) rotate(calc(45deg + var(--p) * 90deg));
}

.home_course_ho_pg_shape_plus {
  color: rgba(224, 168, 61, 0.85);
}

/* ============================================================
   Header
   ============================================================ */

.home_course_ho_pg_head {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  margin-bottom: 34px;
}

.home_course_ho_pg_eyebrow {
  margin-bottom: 12px;
  font-size: 11.5px;
  font-weight: 800;
  letter-spacing: 0.14em;
  text-transform: uppercase;
  color: #4a1a9e;
}

.home_course_ho_pg_title {
  max-width: 640px;
  margin: 0 0 24px;
  font-size: clamp(28px, 3.6vw, 44px);
  font-weight: 800;
  line-height: 1.15;
  letter-spacing: -0.015em;
  color: #0f0a2a;
  text-wrap: balance;
}

/* ---------- Toggle ---------- */

.home_course_ho_pg_toggle {
  position: relative;
  display: inline-grid;
  grid-template-columns: 1fr 1fr;
  padding: 5px;
  margin-bottom: 18px;
  border: 1px solid #e4dcf9;
  border-radius: 12px;
  background: #ffffff;
  box-shadow: 0 8px 22px rgba(74, 26, 158, 0.08);
}

.home_course_ho_pg_toggle_pill {
  position: absolute;
  top: 5px;
  bottom: 5px;
  left: 5px;
  width: calc((100% - 10px) / 2);
  border-radius: 8px;
  background: linear-gradient(100deg, #4a1a9e 0%, #6a1fc2 100%);
  box-shadow: 0 8px 18px rgba(74, 26, 158, 0.32);
  transition: transform 0.45s cubic-bezier(0.34, 1.4, 0.64, 1);
}

.home_course_ho_pg_toggle_btn {
  position: relative;
  z-index: 1;
  min-width: 96px;
  padding: 9px 18px;
  border: 0;
  border-radius: 8px;
  background: transparent;
  font-family: inherit;
  font-size: 12.5px;
  font-weight: 700;
  color: #4d4868;
  cursor: pointer;
  transition: color 0.3s ease;
}

.home_course_ho_pg_toggle_btn_active {
  color: #ffffff;
}

.home_course_ho_pg_toggle_btn:focus-visible {
  outline: 3px solid #e0a83d;
  outline-offset: 2px;
}

.home_course_ho_pg_desc {
  max-width: 560px;
  margin: 0;
  font-size: 14.5px;
  line-height: 1.6;
  color: #5d5978;
  animation: home_course_ho_pg_fade 0.5s ease both;
}

@keyframes home_course_ho_pg_fade {
  from {
    opacity: 0;
    transform: translateY(8px);
  }
  to {
    opacity: 1;
    transform: none;
  }
}

/* header reveal */
.home_course_ho_pg_eyebrow,
.home_course_ho_pg_title,
.home_course_ho_pg_toggle {
  opacity: 0;
  transform: translateY(24px);
  transition: opacity 0.7s ease, transform 0.8s cubic-bezier(0.22, 1, 0.36, 1);
}

.home_course_ho_pg_title {
  transition-delay: 0.1s;
}

.home_course_ho_pg_toggle {
  transition-delay: 0.2s;
}

.home_course_ho_pg_in .home_course_ho_pg_eyebrow,
.home_course_ho_pg_in .home_course_ho_pg_title,
.home_course_ho_pg_in .home_course_ho_pg_toggle {
  opacity: 1;
  transform: none;
}

/* ============================================================
   Cards — 3 on the first row, 2 centred below
   ============================================================ */

.home_course_ho_pg_grid {
  display: grid;
  grid-template-columns: repeat(6, minmax(0, 1fr));
  gap: 22px;
  align-items: stretch;
}

.home_course_ho_pg_cell {
  grid-column: span 2;
  display: flex;
  min-width: 0;
  /* parallax: cells drift at different speeds as you scroll */
  transform: translate3d(0, calc(var(--p) * var(--k, 0) * 1px), 0);
  will-change: transform;
}

.home_course_ho_pg_cell:nth-child(4) {
  grid-column: 2 / span 2;
}

.home_course_ho_pg_cell:nth-child(5) {
  grid-column: 4 / span 2;
}

.home_course_ho_pg_card {
  position: relative;
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 18px 20px 20px;
  border: 1px solid #e4dcf9;
  border-radius: 14px;
  background: linear-gradient(160deg, #ffffff 0%, #f8f4ff 100%);
  box-shadow: 0 14px 34px rgba(74, 26, 158, 0.09);
  opacity: 0;
  transform: translateY(40px) scale(0.96);
  transition:
    opacity 0.7s ease calc(var(--i, 0) * 110ms + 300ms),
    transform 0.9s cubic-bezier(0.22, 1, 0.36, 1) calc(var(--i, 0) * 110ms + 300ms),
    box-shadow 0.35s ease,
    border-color 0.35s ease;
}

.home_course_ho_pg_in .home_course_ho_pg_card {
  opacity: 1;
  transform: none;
}

.home_course_ho_pg_in .home_course_ho_pg_card:hover {
  transform: translateY(-8px);
  border-color: #c9b6f2;
  box-shadow: 0 26px 50px rgba(74, 26, 158, 0.18);
  transition-delay: 0s;
}

.home_course_ho_pg_card_featured {
  border-color: #f2a900;
  box-shadow: 0 16px 36px rgba(242, 169, 0, 0.18);
}

.home_course_ho_pg_in .home_course_ho_pg_card_featured:hover {
  border-color: #f2a900;
  box-shadow: 0 26px 50px rgba(242, 169, 0, 0.3);
}

.home_course_ho_pg_badge {
  position: absolute;
  top: -1px;
  right: 14px;
  padding: 3px 12px 4px;
  border-radius: 0 0 8px 8px;
  background: #f2a900;
  font-size: 10.5px;
  font-weight: 800;
  color: #ffffff;
}

.home_course_ho_pg_tag {
  align-self: flex-start;
  margin-bottom: 14px;
  padding: 3px 10px;
  border-radius: 999px;
  background: #ece2ff;
  font-size: 10.5px;
  font-weight: 700;
  color: #4a1a9e;
}

.home_course_ho_pg_card_title {
  margin: 0 0 8px;
  font-size: 17px;
  font-weight: 800;
  line-height: 1.3;
  color: #0f0a2a;
}

.home_course_ho_pg_duration {
  display: flex;
  align-items: center;
  gap: 7px;
  margin: 0 0 14px;
  font-size: 12px;
  color: #6b6784;
}

.home_course_ho_pg_duration svg {
  flex-shrink: 0;
  color: #8a78b0;
}

.home_course_ho_pg_points {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin: 0 0 16px;
  padding: 0;
  list-style: none;
}

.home_course_ho_pg_point {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  font-size: 12.5px;
  line-height: 1.45;
  color: #2a2445;
}

.home_course_ho_pg_point_icon {
  display: inline-flex;
  flex-shrink: 0;
  margin-top: 1px;
  color: #6a1fc2;
  transition: transform 0.35s cubic-bezier(0.34, 1.56, 0.64, 1);
}

.home_course_ho_pg_point:hover .home_course_ho_pg_point_icon {
  transform: scale(1.25) rotate(-8deg);
}

.home_course_ho_pg_status {
  align-self: flex-start;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  margin-bottom: 14px;
  padding: 4px 11px;
  border-radius: 999px;
  background: #fdecc2;
  font-size: 11px;
  font-weight: 700;
  color: #6b4a00;
}

.home_course_ho_pg_footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-top: auto;
  padding-top: 4px;
}

.home_course_ho_pg_price {
  font-size: 19px;
  font-weight: 800;
  color: #0f0a2a;
}

.home_course_ho_pg_enroll {
  padding: 10px 22px;
  border: 0;
  border-radius: 8px;
  background: linear-gradient(100deg, #4a1a9e 0%, #6a1fc2 100%);
  box-shadow: 0 10px 20px rgba(74, 26, 158, 0.3);
  font-family: inherit;
  font-size: 12.5px;
  font-weight: 800;
  color: #ffffff;
  cursor: pointer;
  transition: transform 0.3s ease, box-shadow 0.3s ease, filter 0.3s ease;
}

.home_course_ho_pg_enroll:hover:not(:disabled) {
  transform: translateY(-3px);
  filter: brightness(1.1);
}

.home_course_ho_pg_enroll:focus-visible {
  outline: 3px solid #e0a83d;
  outline-offset: 3px;
}

/* closed enrollment: muted, not clickable */
.home_course_ho_pg_enroll:disabled {
  background: #b07cb5;
  box-shadow: none;
  cursor: not-allowed;
  opacity: 0.9;
}

/* ============================================================
   Responsive — 1100 / 820 / 560
   ============================================================ */

@media (max-width: 1100px) {
  .home_course_ho_pg_section {
    padding: 68px 0 84px;
  }

  .home_course_ho_pg_grid {
    gap: 18px;
  }

  .home_course_ho_pg_card {
    padding: 16px 16px 18px;
  }

  .home_course_ho_pg_card_title {
    font-size: 16px;
  }
}

/* two columns, last card centred */
@media (max-width: 820px) {
  .home_course_ho_pg_section {
    padding: 56px 0 72px;
  }

  .home_course_ho_pg_grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .home_course_ho_pg_cell,
  .home_course_ho_pg_cell:nth-child(4),
  .home_course_ho_pg_cell:nth-child(5) {
    grid-column: auto;
  }

  .home_course_ho_pg_cell:nth-child(5) {
    grid-column: 1 / -1;
    justify-self: center;
    width: calc(50% - 9px);
  }

  /* gentler parallax on tablets */
  .home_course_ho_pg_cell {
    transform: translate3d(0, calc(var(--p) * var(--k, 0) * 0.5px), 0);
  }

  .home_course_ho_pg_shape {
    opacity: 0.7;
  }
}

/* single column */
@media (max-width: 560px) {
  .home_course_ho_pg_section {
    padding: 44px 0 60px;
  }

  .home_course_ho_pg_container {
    padding: 0 16px;
  }

  .home_course_ho_pg_head {
    margin-bottom: 26px;
  }

  .home_course_ho_pg_toggle {
    display: grid;
    width: 100%;
  }

  .home_course_ho_pg_grid {
    grid-template-columns: minmax(0, 1fr);
    gap: 16px;
  }

  .home_course_ho_pg_cell:nth-child(5) {
    width: auto;
  }

  /* no card drift on phones; background layers keep moving */
  .home_course_ho_pg_cell {
    transform: none;
  }

  .home_course_ho_pg_blob_one,
  .home_course_ho_pg_blob_two,
  .home_course_ho_pg_blob_three {
    width: 360px;
    height: 360px;
  }

  .home_course_ho_pg_shape_ring {
    width: 56px !important;
    height: 56px !important;
  }
}

/* ---------- Reduced motion ---------- */

@media (prefers-reduced-motion: reduce) {
  .home_course_ho_pg_eyebrow,
  .home_course_ho_pg_title,
  .home_course_ho_pg_toggle,
  .home_course_ho_pg_card,
  .home_course_ho_pg_toggle_pill {
    transition: opacity 0.2s ease !important;
    transition-delay: 0s !important;
    transform: none !important;
  }

  .home_course_ho_pg_desc {
    animation: none !important;
  }

  .home_course_ho_pg_blob,
  .home_course_ho_pg_dots,
  .home_course_ho_pg_lines,
  .home_course_ho_pg_shape,
  .home_course_ho_pg_cell {
    transform: none !important;
  }
}


/* ============================================================
   Audience switch (Small business / Professionals / Students)
   ============================================================ */

/* 4 cards: 3 on the first row, the 4th sits at the left (like the design) */
.home_course_ho_pg_grid_four .home_course_ho_pg_cell:nth-child(4) {
  grid-column: 1 / span 2;
}

/* heading fades in again when the audience changes */
.home_course_ho_pg_title_swap {
  animation: home_course_ho_pg_title_swap 0.6s cubic-bezier(0.22, 1, 0.36, 1) both;
}

@keyframes home_course_ho_pg_title_swap {
  from { opacity: 0; transform: translateY(14px); }
  to   { opacity: 1; transform: translateY(0); }
}

@media (max-width: 820px) {
  .home_course_ho_pg_grid_four .home_course_ho_pg_cell:nth-child(4) {
    grid-column: auto;
  }
}

@media (prefers-reduced-motion: reduce) {
  .home_course_ho_pg_title_swap {
    animation: none !important;
  }
}`, "",{"version":3,"sources":["webpack://./src/Components/HomeAiReplace/HomeAiReplace.css"],"names":[],"mappings":"AAAA;;;;iEAIiE;;AAEjE;EACE,MAAM;EACN,kBAAkB;EAClB,WAAW;EACX,oBAAoB;EACpB,0EAA0E;EAC1E,4CAA4C;EAC5C,cAAc;EACd,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,iBAAiB;EACjB,cAAc;EACd,eAAe;AACjB;;AAEA;;iEAEiE;;AAEjE;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA,oCAAoC;AACpC;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,2FAA2F;EAC3F,oDAAoD;AACtD;;AAEA;EACE,QAAQ;EACR,aAAa;EACb,YAAY;EACZ,aAAa;EACb,2FAA2F;EAC3F,wEAAwE;AAC1E;;AAEA;EACE,cAAc;EACd,SAAS;EACT,YAAY;EACZ,aAAa;EACb,wFAAwF;EACxF,wEAAwE;AAC1E;;AAEA,wCAAwC;AACxC;EACE,kBAAkB;EAClB,eAAe;EACf,2FAA2F;EAC3F,0BAA0B;EAE1B,yFAAyF;EACzF,aAAa;EACb,mDAAmD;EACnD,sBAAsB;AACxB;;AAEA,8CAA8C;AAC9C;EACE,kBAAkB;EAClB,eAAe;EACf;;;;;;GAMC;EAED,8EAA8E;EAC9E,oDAAoD;EACpD,sBAAsB;AACxB;;AAEA,+DAA+D;AAC/D;EACE,kBAAkB;EAClB,cAAc;EACd,8BAA8B;EAC9B,4FAA4F;EAC5F,sBAAsB;AACxB;;AAEA;EACE,0CAA0C;EAC1C,kBAAkB;AACpB;;AAEA;EACE,yCAAyC;EACzC,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,oCAAoC;AACtC;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,0CAA0C;EAC1C,kBAAkB;EAClB,oGAAoG;AACtG;;AAEA;EACE,+BAA+B;AACjC;;AAEA;;iEAEiE;;AAEjE;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,mCAAmC;EACnC,gBAAgB;EAChB,iBAAiB;EACjB,wBAAwB;EACxB,cAAc;EACd,kBAAkB;AACpB;;AAEA,iCAAiC;;AAEjC;EACE,kBAAkB;EAClB,oBAAoB;EACpB,8BAA8B;EAC9B,YAAY;EACZ,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;EACnB,8CAA8C;AAChD;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,SAAS;EACT,8BAA8B;EAC9B,kBAAkB;EAClB,6DAA6D;EAC7D,8CAA8C;EAC9C,4DAA4D;AAC9D;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,eAAe;EACf,iBAAiB;EACjB,SAAS;EACT,kBAAkB;EAClB,uBAAuB;EACvB,oBAAoB;EACpB,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,gDAAgD;AAClD;;AAEA;EACE;IACE,UAAU;IACV,0BAA0B;EAC5B;EACA;IACE,UAAU;IACV,eAAe;EACjB;AACF;;AAEA,kBAAkB;AAClB;;;EAGE,UAAU;EACV,2BAA2B;EAC3B,4EAA4E;AAC9E;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;;;EAGE,UAAU;EACV,eAAe;AACjB;;AAEA;;iEAEiE;;AAEjE;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;EACT,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,YAAY;EACZ,4DAA4D;EAC5D,gEAAgE;EAChE,sBAAsB;AACxB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,uBAAuB;EACvB,yBAAyB;EACzB,mBAAmB;EACnB,6DAA6D;EAC7D,+CAA+C;EAC/C,UAAU;EACV,uCAAuC;EACvC;;;;2BAIyB;AAC3B;;AAEA;EACE,UAAU;EACV,eAAe;AACjB;;AAEA;EACE,2BAA2B;EAC3B,qBAAqB;EACrB,+CAA+C;EAC/C,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;EACrB,+CAA+C;AACjD;;AAEA;EACE,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,qBAAqB;EACrB,0BAA0B;EAC1B,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,sBAAsB;EACtB,mBAAmB;EACnB,iBAAiB;EACjB,oBAAoB;EACpB,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,gBAAgB;EAChB,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,QAAQ;EACR,iBAAiB;EACjB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,cAAc;EACd,eAAe;EACf,cAAc;EACd,6DAA6D;AAC/D;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,sBAAsB;EACtB,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;EACnB,iBAAiB;EACjB,oBAAoB;EACpB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,kBAAkB;EAClB,6DAA6D;EAC7D,8CAA8C;EAC9C,oBAAoB;EACpB,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,uEAAuE;AACzE;;AAEA;EACE,2BAA2B;EAC3B,uBAAuB;AACzB;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA,4CAA4C;AAC5C;EACE,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,YAAY;AACd;;AAEA;;iEAEiE;;AAEjE;EACE;IACE,oBAAoB;EACtB;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA,mCAAmC;AACnC;EACE;IACE,oBAAoB;EACtB;;EAEA;IACE,gDAAgD;EAClD;;EAEA;;;IAGE,iBAAiB;EACnB;;EAEA;IACE,mBAAmB;IACnB,oBAAoB;IACpB,sBAAsB;EACxB;;EAEA,gCAAgC;EAChC;IACE,kEAAkE;EACpE;;EAEA;IACE,YAAY;EACd;AACF;;AAEA,kBAAkB;AAClB;EACE;IACE,oBAAoB;EACtB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,WAAW;EACb;;EAEA;IACE,qCAAqC;IACrC,SAAS;EACX;;EAEA;IACE,WAAW;EACb;;EAEA,2DAA2D;EAC3D;IACE,eAAe;EACjB;;EAEA;;;IAGE,YAAY;IACZ,aAAa;EACf;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;EACzB;AACF;;AAEA,yCAAyC;;AAEzC;EACE;;;;;IAKE,wCAAwC;IACxC,+BAA+B;IAC/B,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;;;;;IAKE,0BAA0B;EAC5B;AACF;;;AAGA;;iEAEiE;;AAEjE,4EAA4E;AAC5E;EACE,uBAAuB;AACzB;;AAEA,qDAAqD;AACrD;EACE,gFAAgF;AAClF;;AAEA;EACE,OAAO,UAAU,EAAE,2BAA2B,EAAE;EAChD,OAAO,UAAU,EAAE,wBAAwB,EAAE;AAC/C;;AAEA;EACE;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF","sourcesContent":["/* ============================================================\n   HomeAiReplace — \"Courses we offer\" with parallax background\n   Prefix: home_course_ho_pg_ · no :root variables · no green\n   --p (set by JS on the section) = scroll progress from -1 to 1\n   ============================================================ */\n\n.home_course_ho_pg_section {\n  --p: 0;\n  position: relative;\n  width: 100%;\n  padding: 80px 0 96px;\n  background: linear-gradient(180deg, #f3ecff 0%, #f8f4ff 55%, #fbf8ff 100%);\n  font-family: \"Manrope\", \"Roboto\", sans-serif;\n  color: #0f0a2a;\n  overflow: hidden;\n  isolation: isolate;\n}\n\n.home_course_ho_pg_container {\n  position: relative;\n  z-index: 2;\n  max-width: 1200px;\n  margin: 0 auto;\n  padding: 0 24px;\n}\n\n/* ============================================================\n   Parallax background — each layer moves at its own speed\n   ============================================================ */\n\n.home_course_ho_pg_bg {\n  position: absolute;\n  inset: 0;\n  z-index: 0;\n  pointer-events: none;\n  overflow: hidden;\n}\n\n.home_course_ho_pg_blob {\n  position: absolute;\n  border-radius: 50%;\n  filter: blur(10px);\n  will-change: transform;\n}\n\n/* far layer: slow, big soft glows */\n.home_course_ho_pg_blob_one {\n  top: -160px;\n  left: -180px;\n  width: 560px;\n  height: 560px;\n  background: radial-gradient(circle, rgba(106, 31, 194, 0.26) 0%, rgba(106, 31, 194, 0) 68%);\n  transform: translate3d(0, calc(var(--p) * 150px), 0);\n}\n\n.home_course_ho_pg_blob_two {\n  top: 30%;\n  right: -200px;\n  width: 620px;\n  height: 620px;\n  background: radial-gradient(circle, rgba(224, 168, 61, 0.26) 0%, rgba(224, 168, 61, 0) 68%);\n  transform: translate3d(calc(var(--p) * -60px), calc(var(--p) * 90px), 0);\n}\n\n.home_course_ho_pg_blob_three {\n  bottom: -220px;\n  left: 20%;\n  width: 640px;\n  height: 640px;\n  background: radial-gradient(circle, rgba(74, 26, 158, 0.2) 0%, rgba(74, 26, 158, 0) 68%);\n  transform: translate3d(calc(var(--p) * 80px), calc(var(--p) * 130px), 0);\n}\n\n/* mid layer: dot grid drifting slowly */\n.home_course_ho_pg_dots {\n  position: absolute;\n  inset: -120px 0;\n  background-image: radial-gradient(circle, rgba(74, 26, 158, 0.18) 1.4px, transparent 1.6px);\n  background-size: 34px 34px;\n  -webkit-mask-image: linear-gradient(180deg, transparent 0%, #000 25%, #000 75%, transparent 100%);\n  mask-image: linear-gradient(180deg, transparent 0%, #000 25%, #000 75%, transparent 100%);\n  opacity: 0.55;\n  transform: translate3d(0, calc(var(--p) * 60px), 0);\n  will-change: transform;\n}\n\n/* faint diagonal lines moving the other way */\n.home_course_ho_pg_lines {\n  position: absolute;\n  inset: -160px 0;\n  background-image: repeating-linear-gradient(\n    115deg,\n    rgba(224, 168, 61, 0.1) 0,\n    rgba(224, 168, 61, 0.1) 1px,\n    transparent 1px,\n    transparent 84px\n  );\n  -webkit-mask-image: linear-gradient(90deg, transparent 0%, #000 35%, transparent 100%);\n  mask-image: linear-gradient(90deg, transparent 0%, #000 35%, transparent 100%);\n  transform: translate3d(0, calc(var(--p) * -90px), 0);\n  will-change: transform;\n}\n\n/* near layer: floating shapes, each with its own speed (--k) */\n.home_course_ho_pg_shape {\n  position: absolute;\n  display: block;\n  color: rgba(106, 31, 194, 0.5);\n  transform: translate3d(0, calc(var(--p) * var(--k) * 1px), 0) rotate(calc(var(--p) * 40deg));\n  will-change: transform;\n}\n\n.home_course_ho_pg_shape_ring {\n  border: 2px solid rgba(106, 31, 194, 0.28);\n  border-radius: 50%;\n}\n\n.home_course_ho_pg_shape_ring_gold {\n  border: 2px solid rgba(224, 168, 61, 0.7);\n  border-radius: 50%;\n}\n\n.home_course_ho_pg_shape_dot {\n  border-radius: 50%;\n  background: rgba(106, 31, 194, 0.35);\n}\n\n.home_course_ho_pg_shape_dot_gold {\n  border-radius: 50%;\n  background: #e0a83d;\n  opacity: 0.8;\n}\n\n.home_course_ho_pg_shape_diamond {\n  border: 2px solid rgba(224, 168, 61, 0.75);\n  border-radius: 4px;\n  transform: translate3d(0, calc(var(--p) * var(--k) * 1px), 0) rotate(calc(45deg + var(--p) * 90deg));\n}\n\n.home_course_ho_pg_shape_plus {\n  color: rgba(224, 168, 61, 0.85);\n}\n\n/* ============================================================\n   Header\n   ============================================================ */\n\n.home_course_ho_pg_head {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  margin-bottom: 34px;\n}\n\n.home_course_ho_pg_eyebrow {\n  margin-bottom: 12px;\n  font-size: 11.5px;\n  font-weight: 800;\n  letter-spacing: 0.14em;\n  text-transform: uppercase;\n  color: #4a1a9e;\n}\n\n.home_course_ho_pg_title {\n  max-width: 640px;\n  margin: 0 0 24px;\n  font-size: clamp(28px, 3.6vw, 44px);\n  font-weight: 800;\n  line-height: 1.15;\n  letter-spacing: -0.015em;\n  color: #0f0a2a;\n  text-wrap: balance;\n}\n\n/* ---------- Toggle ---------- */\n\n.home_course_ho_pg_toggle {\n  position: relative;\n  display: inline-grid;\n  grid-template-columns: 1fr 1fr;\n  padding: 5px;\n  margin-bottom: 18px;\n  border: 1px solid #e4dcf9;\n  border-radius: 12px;\n  background: #ffffff;\n  box-shadow: 0 8px 22px rgba(74, 26, 158, 0.08);\n}\n\n.home_course_ho_pg_toggle_pill {\n  position: absolute;\n  top: 5px;\n  bottom: 5px;\n  left: 5px;\n  width: calc((100% - 10px) / 2);\n  border-radius: 8px;\n  background: linear-gradient(100deg, #4a1a9e 0%, #6a1fc2 100%);\n  box-shadow: 0 8px 18px rgba(74, 26, 158, 0.32);\n  transition: transform 0.45s cubic-bezier(0.34, 1.4, 0.64, 1);\n}\n\n.home_course_ho_pg_toggle_btn {\n  position: relative;\n  z-index: 1;\n  min-width: 96px;\n  padding: 9px 18px;\n  border: 0;\n  border-radius: 8px;\n  background: transparent;\n  font-family: inherit;\n  font-size: 12.5px;\n  font-weight: 700;\n  color: #4d4868;\n  cursor: pointer;\n  transition: color 0.3s ease;\n}\n\n.home_course_ho_pg_toggle_btn_active {\n  color: #ffffff;\n}\n\n.home_course_ho_pg_toggle_btn:focus-visible {\n  outline: 3px solid #e0a83d;\n  outline-offset: 2px;\n}\n\n.home_course_ho_pg_desc {\n  max-width: 560px;\n  margin: 0;\n  font-size: 14.5px;\n  line-height: 1.6;\n  color: #5d5978;\n  animation: home_course_ho_pg_fade 0.5s ease both;\n}\n\n@keyframes home_course_ho_pg_fade {\n  from {\n    opacity: 0;\n    transform: translateY(8px);\n  }\n  to {\n    opacity: 1;\n    transform: none;\n  }\n}\n\n/* header reveal */\n.home_course_ho_pg_eyebrow,\n.home_course_ho_pg_title,\n.home_course_ho_pg_toggle {\n  opacity: 0;\n  transform: translateY(24px);\n  transition: opacity 0.7s ease, transform 0.8s cubic-bezier(0.22, 1, 0.36, 1);\n}\n\n.home_course_ho_pg_title {\n  transition-delay: 0.1s;\n}\n\n.home_course_ho_pg_toggle {\n  transition-delay: 0.2s;\n}\n\n.home_course_ho_pg_in .home_course_ho_pg_eyebrow,\n.home_course_ho_pg_in .home_course_ho_pg_title,\n.home_course_ho_pg_in .home_course_ho_pg_toggle {\n  opacity: 1;\n  transform: none;\n}\n\n/* ============================================================\n   Cards — 3 on the first row, 2 centred below\n   ============================================================ */\n\n.home_course_ho_pg_grid {\n  display: grid;\n  grid-template-columns: repeat(6, minmax(0, 1fr));\n  gap: 22px;\n  align-items: stretch;\n}\n\n.home_course_ho_pg_cell {\n  grid-column: span 2;\n  display: flex;\n  min-width: 0;\n  /* parallax: cells drift at different speeds as you scroll */\n  transform: translate3d(0, calc(var(--p) * var(--k, 0) * 1px), 0);\n  will-change: transform;\n}\n\n.home_course_ho_pg_cell:nth-child(4) {\n  grid-column: 2 / span 2;\n}\n\n.home_course_ho_pg_cell:nth-child(5) {\n  grid-column: 4 / span 2;\n}\n\n.home_course_ho_pg_card {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  padding: 18px 20px 20px;\n  border: 1px solid #e4dcf9;\n  border-radius: 14px;\n  background: linear-gradient(160deg, #ffffff 0%, #f8f4ff 100%);\n  box-shadow: 0 14px 34px rgba(74, 26, 158, 0.09);\n  opacity: 0;\n  transform: translateY(40px) scale(0.96);\n  transition:\n    opacity 0.7s ease calc(var(--i, 0) * 110ms + 300ms),\n    transform 0.9s cubic-bezier(0.22, 1, 0.36, 1) calc(var(--i, 0) * 110ms + 300ms),\n    box-shadow 0.35s ease,\n    border-color 0.35s ease;\n}\n\n.home_course_ho_pg_in .home_course_ho_pg_card {\n  opacity: 1;\n  transform: none;\n}\n\n.home_course_ho_pg_in .home_course_ho_pg_card:hover {\n  transform: translateY(-8px);\n  border-color: #c9b6f2;\n  box-shadow: 0 26px 50px rgba(74, 26, 158, 0.18);\n  transition-delay: 0s;\n}\n\n.home_course_ho_pg_card_featured {\n  border-color: #f2a900;\n  box-shadow: 0 16px 36px rgba(242, 169, 0, 0.18);\n}\n\n.home_course_ho_pg_in .home_course_ho_pg_card_featured:hover {\n  border-color: #f2a900;\n  box-shadow: 0 26px 50px rgba(242, 169, 0, 0.3);\n}\n\n.home_course_ho_pg_badge {\n  position: absolute;\n  top: -1px;\n  right: 14px;\n  padding: 3px 12px 4px;\n  border-radius: 0 0 8px 8px;\n  background: #f2a900;\n  font-size: 10.5px;\n  font-weight: 800;\n  color: #ffffff;\n}\n\n.home_course_ho_pg_tag {\n  align-self: flex-start;\n  margin-bottom: 14px;\n  padding: 3px 10px;\n  border-radius: 999px;\n  background: #ece2ff;\n  font-size: 10.5px;\n  font-weight: 700;\n  color: #4a1a9e;\n}\n\n.home_course_ho_pg_card_title {\n  margin: 0 0 8px;\n  font-size: 17px;\n  font-weight: 800;\n  line-height: 1.3;\n  color: #0f0a2a;\n}\n\n.home_course_ho_pg_duration {\n  display: flex;\n  align-items: center;\n  gap: 7px;\n  margin: 0 0 14px;\n  font-size: 12px;\n  color: #6b6784;\n}\n\n.home_course_ho_pg_duration svg {\n  flex-shrink: 0;\n  color: #8a78b0;\n}\n\n.home_course_ho_pg_points {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  margin: 0 0 16px;\n  padding: 0;\n  list-style: none;\n}\n\n.home_course_ho_pg_point {\n  display: flex;\n  align-items: flex-start;\n  gap: 8px;\n  font-size: 12.5px;\n  line-height: 1.45;\n  color: #2a2445;\n}\n\n.home_course_ho_pg_point_icon {\n  display: inline-flex;\n  flex-shrink: 0;\n  margin-top: 1px;\n  color: #6a1fc2;\n  transition: transform 0.35s cubic-bezier(0.34, 1.56, 0.64, 1);\n}\n\n.home_course_ho_pg_point:hover .home_course_ho_pg_point_icon {\n  transform: scale(1.25) rotate(-8deg);\n}\n\n.home_course_ho_pg_status {\n  align-self: flex-start;\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  margin-bottom: 14px;\n  padding: 4px 11px;\n  border-radius: 999px;\n  background: #fdecc2;\n  font-size: 11px;\n  font-weight: 700;\n  color: #6b4a00;\n}\n\n.home_course_ho_pg_footer {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  margin-top: auto;\n  padding-top: 4px;\n}\n\n.home_course_ho_pg_price {\n  font-size: 19px;\n  font-weight: 800;\n  color: #0f0a2a;\n}\n\n.home_course_ho_pg_enroll {\n  padding: 10px 22px;\n  border: 0;\n  border-radius: 8px;\n  background: linear-gradient(100deg, #4a1a9e 0%, #6a1fc2 100%);\n  box-shadow: 0 10px 20px rgba(74, 26, 158, 0.3);\n  font-family: inherit;\n  font-size: 12.5px;\n  font-weight: 800;\n  color: #ffffff;\n  cursor: pointer;\n  transition: transform 0.3s ease, box-shadow 0.3s ease, filter 0.3s ease;\n}\n\n.home_course_ho_pg_enroll:hover:not(:disabled) {\n  transform: translateY(-3px);\n  filter: brightness(1.1);\n}\n\n.home_course_ho_pg_enroll:focus-visible {\n  outline: 3px solid #e0a83d;\n  outline-offset: 3px;\n}\n\n/* closed enrollment: muted, not clickable */\n.home_course_ho_pg_enroll:disabled {\n  background: #b07cb5;\n  box-shadow: none;\n  cursor: not-allowed;\n  opacity: 0.9;\n}\n\n/* ============================================================\n   Responsive — 1100 / 820 / 560\n   ============================================================ */\n\n@media (max-width: 1100px) {\n  .home_course_ho_pg_section {\n    padding: 68px 0 84px;\n  }\n\n  .home_course_ho_pg_grid {\n    gap: 18px;\n  }\n\n  .home_course_ho_pg_card {\n    padding: 16px 16px 18px;\n  }\n\n  .home_course_ho_pg_card_title {\n    font-size: 16px;\n  }\n}\n\n/* two columns, last card centred */\n@media (max-width: 820px) {\n  .home_course_ho_pg_section {\n    padding: 56px 0 72px;\n  }\n\n  .home_course_ho_pg_grid {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n  }\n\n  .home_course_ho_pg_cell,\n  .home_course_ho_pg_cell:nth-child(4),\n  .home_course_ho_pg_cell:nth-child(5) {\n    grid-column: auto;\n  }\n\n  .home_course_ho_pg_cell:nth-child(5) {\n    grid-column: 1 / -1;\n    justify-self: center;\n    width: calc(50% - 9px);\n  }\n\n  /* gentler parallax on tablets */\n  .home_course_ho_pg_cell {\n    transform: translate3d(0, calc(var(--p) * var(--k, 0) * 0.5px), 0);\n  }\n\n  .home_course_ho_pg_shape {\n    opacity: 0.7;\n  }\n}\n\n/* single column */\n@media (max-width: 560px) {\n  .home_course_ho_pg_section {\n    padding: 44px 0 60px;\n  }\n\n  .home_course_ho_pg_container {\n    padding: 0 16px;\n  }\n\n  .home_course_ho_pg_head {\n    margin-bottom: 26px;\n  }\n\n  .home_course_ho_pg_toggle {\n    display: grid;\n    width: 100%;\n  }\n\n  .home_course_ho_pg_grid {\n    grid-template-columns: minmax(0, 1fr);\n    gap: 16px;\n  }\n\n  .home_course_ho_pg_cell:nth-child(5) {\n    width: auto;\n  }\n\n  /* no card drift on phones; background layers keep moving */\n  .home_course_ho_pg_cell {\n    transform: none;\n  }\n\n  .home_course_ho_pg_blob_one,\n  .home_course_ho_pg_blob_two,\n  .home_course_ho_pg_blob_three {\n    width: 360px;\n    height: 360px;\n  }\n\n  .home_course_ho_pg_shape_ring {\n    width: 56px !important;\n    height: 56px !important;\n  }\n}\n\n/* ---------- Reduced motion ---------- */\n\n@media (prefers-reduced-motion: reduce) {\n  .home_course_ho_pg_eyebrow,\n  .home_course_ho_pg_title,\n  .home_course_ho_pg_toggle,\n  .home_course_ho_pg_card,\n  .home_course_ho_pg_toggle_pill {\n    transition: opacity 0.2s ease !important;\n    transition-delay: 0s !important;\n    transform: none !important;\n  }\n\n  .home_course_ho_pg_desc {\n    animation: none !important;\n  }\n\n  .home_course_ho_pg_blob,\n  .home_course_ho_pg_dots,\n  .home_course_ho_pg_lines,\n  .home_course_ho_pg_shape,\n  .home_course_ho_pg_cell {\n    transform: none !important;\n  }\n}\n\n\n/* ============================================================\n   Audience switch (Small business / Professionals / Students)\n   ============================================================ */\n\n/* 4 cards: 3 on the first row, the 4th sits at the left (like the design) */\n.home_course_ho_pg_grid_four .home_course_ho_pg_cell:nth-child(4) {\n  grid-column: 1 / span 2;\n}\n\n/* heading fades in again when the audience changes */\n.home_course_ho_pg_title_swap {\n  animation: home_course_ho_pg_title_swap 0.6s cubic-bezier(0.22, 1, 0.36, 1) both;\n}\n\n@keyframes home_course_ho_pg_title_swap {\n  from { opacity: 0; transform: translateY(14px); }\n  to   { opacity: 1; transform: translateY(0); }\n}\n\n@media (max-width: 820px) {\n  .home_course_ho_pg_grid_four .home_course_ho_pg_cell:nth-child(4) {\n    grid-column: auto;\n  }\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .home_course_ho_pg_title_swap {\n    animation: none !important;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
